export const environment = {
    production: true,
    // apiUrl: 'https://cementcert.holcim.info/',
    apiUrl: 'https://cement-cert-qa.amrize.com/',

};